module.exports = __webpack_public_path__ + "img/terraform.48ca1608.png";